/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Tlm_3Inputs */

const en_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`release_channel`)
};

const ar_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قناة الإصدار`)
};

const bn_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`release_channel`)
};

const de_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`release_channel`)
};

const es_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`canal_lanzamiento`)
};

const fr_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`release_channel`)
};

const pt_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`canal_de_lançamento`)
};

const zh_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布通道`)
};

const tr_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yayın_kanalı`)
};

const ru_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Release_channel`)
};

const pl_svc_mobile_app_development_tlm_3 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kanał_wydania`)
};

/**
* | output |
* | --- |
* | "release_channel" |
*
* @param {Svc_Mobile_App_Development_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_tlm_3 = /** @type {((inputs?: Svc_Mobile_App_Development_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_tlm_3(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_tlm_3(inputs)
	if (locale === "de") return de_svc_mobile_app_development_tlm_3(inputs)
	if (locale === "es") return es_svc_mobile_app_development_tlm_3(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_tlm_3(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_tlm_3(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_tlm_3(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_tlm_3(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_tlm_3(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_tlm_3(inputs)
	return en_svc_mobile_app_development_tlm_3(inputs)
});
export { svc_mobile_app_development_tlm_3 as "svc_mobile-app-development_tlm_3" }